import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
import { CFBaseToastHelpers, CFBaseToastTokens } from './styles';
//
// Element Styles
//
export const CFBaseToastStyles = {
    Actions: css `
    padding: ${CFTokens.SPACER.B}px 0 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: ${CFTokens.SPACER.B}px;
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: ${CFBaseToastHelpers.actionsBorderColor};
  `,
    ActionsSpacer: css `
    flex: 1;
  `,
    IconWrapper: css `
    box-sizing: border-box;
    width: ${CFBaseToastTokens.ICON_WRAPPER_SIZE}px;
    height: ${CFBaseToastTokens.ICON_WRAPPER_SIZE}px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    ${CFBaseToastHelpers.iconWrapperVariants};
  `,
    MainWrapper: css `
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: flex-start;
    gap: ${CFTokens.SPACER.D}px;
  `,
    Message: css `
    flex: 1;
  `,
    Root: css `
    box-sizing: border-box;
    padding: ${CFTokens.SPACER.D}px;
    width: 100%;
    max-width: ${CFBaseToastTokens.MAX_WIDTH}px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
    gap: ${CFTokens.SPACER.D}px;
    border-radius: ${CFTokens.BORDER_RADIUS.C}px;
    background-color: ${CFBaseToastHelpers.rootBackgroundColor};
    box-shadow: ${CFTokens.ELEVATION.C};
  `,
    RootWithCSSTransitions: css `
    transition-duration: ${CFBaseToastTokens.TRANSITION_DURATION}ms;
    transition-timing-function: ease-in-out;
    ${CFBaseToastHelpers.rootCSSTransitions}
  `,
};
